import { memo, useCallback } from 'react';

import { useProductsList } from 'components/ProductsListModal/ProductsListContext';
import SelectedProductItem from 'components/SelectedProductItem';
import { If } from 'shared';
import { CheckboxField, RadioField } from 'shared/Houston';
import { IOffer, IProduct } from 'types/interfaces';

import { CenterIconOffer, ChildOfferItem, OfferItem } from './styles';

interface IProps {
  product: IProduct;
  multipleSelection?: boolean;
  handleChange: (contentId: number, offer: IOffer) => void;
  isProductSelected: (id: number, isOffer?: boolean) => boolean | undefined;
  shouldDisableCheckbox: (id: number) => boolean | undefined;
}
const ProductOffers: React.FC<IProps> = ({
  product,
  multipleSelection,
  handleChange,
  isProductSelected,
  shouldDisableCheckbox
}) => {
  const context = useProductsList();

  const isValidOffer = useCallback(
    (offer: IOffer) => {
      return (
        offer?.isValid ||
        !!context?.selectionProducts.find(product => Number(product?.offerId) === Number(offer?.offerId))
      );
    },
    [context?.selectionProducts]
  );

  return (
    <>
      {product.offers?.map(offer => (
        <ChildOfferItem key={`children-item-${offer.offerId}`} error={isValidOffer(offer) ? 0 : 1}>
          <OfferItem key={`children-item-${offer.offerId}-${offer.offerKey}`}>
            <CenterIconOffer>
              <If condition={!multipleSelection}>
                <RadioField
                  name='radio-selected-product'
                  value={offer.offerId}
                  onChange={() => handleChange(product.contentId, offer)}
                  checked={isProductSelected(Number(offer.offerId), true)}
                />
              </If>
              <If condition={multipleSelection}>
                <CheckboxField
                  name='selected-product'
                  value={offer.offerId}
                  onChange={() => handleChange(product.contentId, offer)}
                  checked={isProductSelected(Number(offer.offerId), true)}
                  disabled={shouldDisableCheckbox(Number(offer.offerId))}
                />
              </If>
            </CenterIconOffer>
            <SelectedProductItem className='product-list-item' offer={offer} hideErrorMessage={isValidOffer(offer)} />
          </OfferItem>
        </ChildOfferItem>
      ))}
    </>
  );
};

export default memo(ProductOffers);
